<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>自定义配置</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">自定义编号规则</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <!--列表-->
        <el-table
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
        >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column  prop="formName" label="目标表单名称">
          </el-table-column>
          <el-table-column label="表单编号生成规则" prop="codeRule">
          </el-table-column>
          <el-table-column align="left" label="操作"  fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="edit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>
      <el-dialog
        title="编辑自定义字段"
        :visible.sync="dialogVisible"
        width="600px"
        top="10vh"
      :show-close="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="closeDialog"
      >
      <CreateLayout v-if="dialogVisible" :fieldData="fieldData" @save="productSave" @close="closeDialog"></CreateLayout>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import CreateLayout from '@/views/customSetting/customRule/CreateLayout';
import {queryCustomRule,addUptCustomRule} from '@/api/business';
export default {
  name: "customForm",
  components:{
      Pagination,
      CreateLayout,
  },
  data() {
    return {

        listData: [],
        loading: false,
        form:{
           condition: {
              factoryId: ""
            },
            currentPage: 1,
            pageSize: 10,
        },
        // 分页参数
        pageparm: {
            currentPage: 1,
            pageSize: 10,
            total: 0
        },
        dialogVisible:false,
        fieldData:{},
        user:JSON.parse(window.localStorage.getItem('userdata')),

    };
  },
  created() {
    this.form['condition']['factoryId'] = this.user['factoryId'];
    this.getList();
  },
  methods: {


    getList(){
       this.loading = true;

      queryCustomRule(this.form).then(res=>{
       this.loading = false;

        if(res['code'] == 200){
            this.pageparm = res['data'];
            this.listData = res['data']['list'];
        }
      })
    },
     // 分页插件事件
    callFather(param) {

        this.form['currentPage'] = param['currentPage'];
        this.form['pageSize'] = param['pageSize'];
        this.getList();
    },
    createProduct(){
        this.fieldData = {},
        this.dialogVisible = true;
    },
      productSave(val){
        if(val){
          val['factoryId'] = this.user['factoryId'];
          val['creater'] = this.user['account'];
          addUptCustomRule(val).then(res=>{

            if(res['code']==200){
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
            }else{
              this.$message.error(res['msg'] || '操作失败！');
            }
            this.getList();
          })

        }
        this.dialogVisible =false;

    },
    closeDialog(){

      this.dialogVisible = false;
    },
    Delete(index,row){
        this.listData.splice(index,1);
    },
    edit(index,row){
        this.fieldData = row;
        this.dialogVisible = true;
    }

  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/customSetting/customRule/customRule.vue